import NoRefundCallout from '../no-refund-callout';

import PickupTimeSection from './pickup-time-section';
import ServiceModePicker from './service-mode-picker';
import StoreSection from './store-section';
import StoreTooFarCallout from './store-too-far-callout';

export function CheckoutPickupDetails() {
  return (
    <>
      <StoreSection />
      <StoreTooFarCallout />
      <NoRefundCallout />
      <ServiceModePicker />
      <PickupTimeSection />
    </>
  );
}
